import CaseFolders from "../CaseFolders";
import Notifications from "../Notifications";
import Overview from "../Overview";

import Settings from "../Settings";

import ViewCaseFolder from "../case-folder/ViewCaseFolder";

import CauseLists from "../CauseLists";
import ViewCauseList from "../cause-list/ViewCauseList";
import PaymentHistory from "../PaymentHistory";
import Users from "../Users";
import Entities from "../Entities";
import ManageOfficials from "../ManageOfficials";
import CRM from "../CRM";

export const AdminRoute = [
  {
    title: "Overview",
    path: "/admin/overview",
    component: Overview,
  },
  {
    title: "Case Folders",
    path: "/admin/case-folders",
    component: CaseFolders,
  },

  {
    title: "View Case Folder",
    path: "/admin/case-folders/view",
    component: ViewCaseFolder,
  },
  {
    title: "Users",
    path: "/admin/users",
    component: Users,
  },
  {
    title: "Entities",
    path: "/admin/entities",
    component: Entities,
  },
  {
    title: "Manage Officials",
    path: "/admin/manage-officials",
    component: ManageOfficials,
  },

  {
    title: "Payments",
    path: "/admin/payments",
    component: PaymentHistory,
  },
  {
    title: "Cause Lists",
    path: "/admin/cause-lists",
    component: CauseLists,
  },
  {
    title: "View Cause List",
    path: "/admin/cause-lists/view",
    component: ViewCauseList,
  },

  {
    title: "CRM",
    path: "/admin/crm",
    component: CRM,
  },
  // {
  //   title: "Notifications",
  //   path: "/admin/notifications",
  //   component: Notifications,
  // },
  {
    title: "Setting",
    path: "/admin/setting",
    component: Settings,
  },
];
